import { isMobile, isTablet } from "react-device-detect";

export const IsMobileOrBrowser = () => {
  // console.log(window.innerWidth, window.innerWidth <= 1200);
  return window.innerWidth <= 900 || (isMobile || isTablet);
};
